import type { CustomerOngoingOrderByStatusLoader } from "@/data/customerDataLoader"
import { API_ROUTES } from "@/routes"

const customerIdParam = "customerId"
const orderStatusParam = "orderStatus"

export type API_ROUTES_CUSTOMER_ONGOING_ORDER_RETURN = CustomerOngoingOrderByStatusLoader | null
export const API_ROUTES_CUSTOMER_ONGOING_ORDER = {
  get: (customerId: string, orderStatus: "MERCHANT_ACCEPTED" | "PENDING") =>
    `${API_ROUTES.customerOngoingOrder}?${customerIdParam}=${customerId}&${orderStatusParam}=${orderStatus}`,
  params: {
    customerId: customerIdParam,
    orderStatus: orderStatusParam,
  },
}
